/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);



// countdownMessage cart_drawer message


document.addEventListener("DOMContentLoaded", function () {

  // var currentDomain = document.querySelector('[data-cart-domain-name="' + window.location.hostname + '"]');
  var currentDomain = document.querySelector('[data-cart-domain-name="lerinwatches.com"]');

  if (currentDomain) {
    
    var timeToSeconds2 = function (timeStr) {
      var timeParts = timeStr.split(":"),
        hours = parseInt(timeParts[0], 10),
        minutes = parseInt(timeParts[1], 10),
        seconds = parseInt(timeParts[2] || 0, 10);
      return hours * 3600 + minutes * 60 + seconds;
    },

    isOffDay2 = function (date) {
      var dayNames = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
        dateString = date.toISOString().split("T")[0];
      return offDays.includes(dayNames[date.getDay()]) || offDays.includes(dateString);
    },

    formatDate2 = function (date) {
      var options = {
        day: "numeric",
        month: "long"
      };
      return date.toLocaleDateString("en-GB", options);
    },

    calculateDeliveryDate2 = function (startDate, totalDays) {
      for (var deliveryDate = new Date(startDate), validDays = 0; validDays < totalDays;) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
        if (!isOffDay2(deliveryDate)) validDays++;
      }
      return deliveryDate;
    },

    updateCountdown2 = function () {
      if (totalSeconds < 0) {
        totalSeconds = 86400;
        deliveryDays++;
        finalDeliveryDate = calculateDeliveryDate2(orderDate, deliveryDays);
        resultDate = formatDate2(finalDeliveryDate);
      }

      var remainingHours = Math.floor(totalSeconds / 3600),
        remainingMinutes = Math.floor((totalSeconds % 3600) / 60),
        remainingSeconds = totalSeconds % 60,

        message = resultDate;

      var msgDiv = document.querySelector("#cartcountdownMessage div");
      if (msgDiv) msgDiv.innerHTML = message;

      totalSeconds--;
    },

    timeToSeconds = timeToSeconds2,
    isOffDay = isOffDay2,
    formatDate = formatDate2,
    calculateDeliveryDate = calculateDeliveryDate2,
    updateCountdown = updateCountdown2,

    cutoffHour = currentDomain.querySelector("#cartcutoffTime")?.value,
    currentTime = currentDomain.querySelector("#cartcurrentTime")?.value,
    deliveryDays = parseInt(currentDomain.querySelector("#cartdeliveryDays")?.value, 10),
    orderDate = new Date(currentDomain.querySelector("#cartorderDate")?.value),

    offDays = currentDomain.querySelector("#cartoffDays")?.value
      .split(",")
      .map(function (day) {
        return day.trim().toLowerCase();
      }),

    time1InSeconds = timeToSeconds2(cutoffHour),
    time2InSeconds = timeToSeconds2(currentTime),
    smallTime = time2InSeconds > time1InSeconds;

    if (smallTime) deliveryDays++;

    var finalDeliveryDate = calculateDeliveryDate2(orderDate, deliveryDays),
      resultDate = formatDate2(finalDeliveryDate),

      timeDiffInSeconds = Math.abs(time1InSeconds - time2InSeconds),

      htmlHrs = smallTime ? 23 - Math.floor(timeDiffInSeconds / 3600) : Math.floor(timeDiffInSeconds / 3600),
      htmlMins = smallTime ? 59 - Math.floor((timeDiffInSeconds % 3600) / 60) : Math.floor((timeDiffInSeconds % 3600) / 60),
      htmlSecs = smallTime ? 59 - (timeDiffInSeconds % 60) : (timeDiffInSeconds % 60),

      totalSeconds = htmlHrs * 3600 + htmlMins * 60 + htmlSecs;

    setInterval(updateCountdown2, 1000);

    setTimeout(function () {
      var el = document.getElementById("cartcountdownMessage");
      if (el) {
        el.style.display = "flex";
      }
    }, 1100);
  }

});
